import { Router } from '@angular/router';
import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';
import { Component } from '@angular/core';

@Component({
    selector: 'hm-auth-component',
    template: `
      <router-outlet></router-outlet>
  `,
})
export class HmAuthComponent {
    menu = [];

    constructor(
        protected hmService: HappyMammaService,
        protected router: Router,
    ) {
    }
}
